import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class CommunicationsService {
    constructor(private http: HttpClient) { }

    createCommunication(communication) {
        return this.http.post<any[]>(`${environment.apiUrl}/communications/create`, communication);
    }

    getCommunication(id) {
        return this.http.get<any[]>(`${environment.apiUrl}/communications/${id}`);
    }
    getAll(params) {
        return this.http.get<any[]>(`${environment.apiUrl}/communications`, { params: params });
    }

    sendMessage(communicationId, msg) {
        return this.http.post<any[]>(`${environment.apiUrl}/communications/send-message/${communicationId}`, msg);
    }


    askRequest(params) {
        return this.http.post<any[]>(`${environment.apiUrl}/communications/ask-request`, params);
    }
}